// extracted by mini-css-extract-plugin
export default {"homebg":"Home_homebg__+UijF","leftdiv":"Home_leftdiv__ld04p","resume_btn":"Home_resume_btn__he-53","rightdiv":"Home_rightdiv__Q-LWU"};